<!-- InserirDadosBasico.svelte -->
<script>
  import { navigate } from "svelte-routing";
  import Conexoes from "../../Classes/Conexoes.js";
  import Constantes from "../../Classes/Constantes.js";
  import { Tipo } from "../../Classes/ItemInserir.js";
  import CaixaDeDialogo from "../../componentes_basicos/CaixaDeDialogo.svelte";
  import CaixaDeDialogo2 from "../../componentes_basicos/CaixaDeDialogo.svelte";
  import LoadingTela from "../../componentes_basicos/LoadingTela.svelte";
  import Toast from "../../componentes_basicos/Toast.svelte";
  import { createEventDispatcher, onMount } from "svelte";
  import DropDownDb from "../../componentes_basicos/DropDownDB.svelte";
  import consolar from "../../Classes/Consolar.js";
  import { Switch } from "@svelteuidev/core";
  export let id;
  export let itens = [];
  export let apiEdicao;
  export let apiConsultaEdicao;
   export let titulo="Altera dados do usuário";
  export let query_code_carregar_edicao;
  export let tabela;
  export let tabelaEdicao;
  export let navegar_para = "";
  export let edita = true;
  export let deleta = true;
  export let textoBotaoEditar = "Salvar edição";
  export let textoBotaoDeletar = "Deletar";
  let senha;
  let confirmacaoSenha;
  /*
   export let query_code_editar; //talvez implementacao futura
  export let query_code_apagar; //talvez implementacao futura
  */
  let teste = "bla bla ";
  let modoApagar = false;
  let mensagem = "";
  let parametros = {};

  let parametrosCarregaDados = {
    id: id,
    query_code: query_code_carregar_edicao,
    tabela: tabela,
  };
  let carregando = false;
  let carregado = false;
  let retorno = "";
  let response = "";
  let lista_elementos = [];
  const dispatch = createEventDispatcher();
  let conexoes = new Conexoes();
  onMount(carregarDados);

  function MudaTG(e) {
    if (!e || e == 0) {
      e = 1;
    } else {
      e = 0;
    }
    return e;
  }
  async function carregarDados() {
    carregando = true;
    const response = await conexoes.conecta(
      apiConsultaEdicao,
      parametrosCarregaDados,
    );
    console.log(response[0]);
    retorno = response[0]; // Supondo que o retorno seja um objeto com os dados
    lista_elementos = retorno;
    console.log(retorno);

    carregado = true;
    carregando = false;
  }

  export function SalvaEdicao() {
    let rotuloErro = validarObrigatorios(retorno);

    console.log("aqui1");
    if (rotuloErro != "-valido-") {
      mostrarDialogo(Constantes.msg_campos_obrigatorios + rotuloErro);

      console.log("aqui2");

      return;
    }
    rotuloErro = validarFormatos();
    if (rotuloErro != "-valido-") {
      mostrarDialogo(Constantes.msg_formato_invalido + rotuloErro);
      console.log("aqui3");
      return;
    }
    ChecaSenha();
    atualizarParametros();
    //  itens.forEach((item) => {
    //  parametros[item.nomeColuna] = retorno[item.valor];
    //});
    if (!tabelaEdicao) {
      parametros["tabela"] = tabela;
    } else {
      parametros["tabela"] = tabelaEdicao;
    }

    parametros["id_update"] = id;
    if (modoApagar) {
      parametros["modo_code"] = "apagar";
    } else {
      parametros["modo_code"] = "editar";
    }
    dispatch("parametrosInseridos", parametros);
    conectar();
  }

  // Função para limpar os campos
  export function limparCampos() {
    retorno = {};
  }
  // Função para verificar se todos os campos obrigatórios foram preenchidos
  function validarObrigatorios(itens) {
    console.log(itens);
    for (let chave in itens) {
      if (itens.hasOwnProperty(chave)) {
        let item = itens[chave];
        if (
          item.obrigatorio &&
          (item.valor === "" ||
            item.valor === null ||
            (typeof item.valor === "string" && item.valor.trim() === ""))
        ) {
          return item.rotulo; // Se o valor for vazio, retorna o rótulo
        }
      }
    }

    console.log("aqui---");
    return "-valido-"; // Retorna '-valido-' se todos os campos obrigatórios estiverem preenchidos
  }

  // Função para verificar se os campos possuem formatos válidos
  function validarFormatos() {
    // Validação de formatos
    const regex = {
      [Tipo.NUMERO]: /^\d+$/,
      [Tipo.EMAIL]: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
      [Tipo.TELEFONE]: /^\d{10,11}$/,
      // Adicione mais tipos de validação conforme necessário
    };

    for (let item of itens) {
      if (
        regex[item.tipo] &&
        item.valor !== undefined && // Verifica se item.valor é undefined
        typeof item.valor === "string" &&
        item.valor.trim() !== "" &&
        !regex[item.tipo].test(item.valor)
      ) {
        return item.rotulo; // Se o formato não corresponder à regex, retorna falso
      }
    }

    return "-valido-"; // Se todas as validações passarem, retorna verdadeiro
  }
  export async function conectar() {
    mensagem = "";
    conexoes = new Conexoes();
    carregando = true;
    carregado = false;
    response = await conexoes.conecta(apiEdicao, parametros);
    if (response && response.sucesso) {
      console.log("atualizado com sucesso!");
      if (modoApagar) {
        mensagem = Constantes.msg_apagados_sucesso;
      } else {
        mensagem = Constantes.msg_alterado_sucesso;
      }
    } else if (!response.sucesso && response.motivo == "duplicado") {
      mensagem = Constantes.msg_erro_alteracao_dupla;
    } else {
      mensagem = Constantes.msg_erro_conexao_bd;
    }
    carregado = true; // Esconde o ícone de carregamento quando terminar
    carregando = false;
  }
  function getInputClass(item) {
    return `form-control${item.tipo === Tipo.TELEFONE ? " tel-input" : ""}`;
  }
  function mostrarDialogo(msg) {
    mensagem = msg;
    console.log("aqui4" + mensagem);
  }
  // Função para atualizar os parâmetros com os valores dos inputs
  function atualizarParametros() {
    for (let item of itens) {
      if (
        item.tipo === Tipo.PASSWORD &&
        item.rotulo.endsWith(" (Confirmação)")
      ) {
        return;
      }
      parametros[item.nomeColuna] = retorno[item.nomeColuna];
    }
  }
  function ConfirmaEdicao(e) {
    response = "";
    if (e == 2) {
      mensagem = Constantes.msg_confirma_alterar_dados;
      modoApagar = false;
    } else {
      mensagem = Constantes.msg_confirma_apagar_dados;
      modoApagar = true;
    }
  }
  function NavegarAposAtualizar() {
    if (navegar_para != "") {
      navigate(navegar_para);
    }
    console.log("navegando");
  }
  function PegaValor(e) {
    let valor = e;
    return valor;
  }

  function ChecaSenha() {
    if (confirmacaoSenha && senha && confirmacaoSenha.value !== senha.value) {
      mostrarDialogo(Constantes.msg_senhas_nao_coincidem);
      parametros = "";
      dispatch("parametrosInseridos", {
        parametros: parametros,
        erro: rotuloErro,
        tipo: "senha",
      });
      return;
    }
  }
</script>

<LoadingTela isLoading={carregando} />

<div class="header-bar">{titulo}</div>
<div class="card1">
  {#each itens as item}
    <div class="form-group">
       {#if item.tipo != Tipo.DIVISOR && item.tipo != Tipo.HIDDEN}
        <label for={item.nomeColuna}
          >{item.rotulo}{#if item.obrigatorio}<span style="color: red;">*</span
            >{/if}</label
        >
      {/if}
      {#if item.tipo === Tipo.TEXTO}
        <input
          type="text"
          bind:value={retorno[item.nomeColuna]}
          placeholder={item.rotulo}
          maxlength={item.tamanho}
          id={item.nomeColuna}
          class="form-control"
          disabled={item.readonly}
        />
      {:else if item.tipo === Tipo.NUMERO}
        <input
          type="number"
          bind:value={retorno[item.nomeColuna]}
          placeholder={item.rotulo}
          id={item.nomeColuna}
          maxlength={item.tamanho}
          class="form-control"
          disabled={item.readonly}
          step={item.passos}
          max={9999999}
        />
      {:else if item.tipo === Tipo.DECIMAL}
        <input
          type="number"
          bind:value={retorno[item.nomeColuna]}
          placeholder={item.rotulo}
          id={item.nomeColuna}
          class="form-control"
          disabled={item.readonly}
          maxlength={item.tamanho}
          step={item.passos}
          max={9999999.9}
          pattern={`\\d+(\\.\\d{1,${item.casas_decimais}})?`}
        />
      {:else if item.tipo === Tipo.PASSWORD}
        <input
          type="password"
          bind:value={retorno[item.nomeColuna]}
          placeholder={item.rotulo}
          id={item.nomeColuna}
          class="form-control"
          disabled={item.readonly}
          maxlength={item.tamanho}
          bind:this={senha}
        />
        <input
          type="password"
          bind:this={confirmacaoSenha}
          maxlength={item.tamanho}
          placeholder={`${item.rotulo} (Confirmação)`}
          id={`${item.nomeColuna}-confirmacao`}
          class="form-control"
          value={retorno[item.nomeColuna]}
        />
      {:else if item.tipo === Tipo.HORA}
        <input
          type="time"
          bind:value={retorno[item.nomeColuna]}
          placeholder={item.rotulo}
          id={item.nomeColuna}
          class="form-control"
          disabled={item.readonly}
          maxlength={item.tamanho}
        />
      {:else if item.tipo === Tipo.EMAIL}
        <input
          type="email"
          bind:value={retorno[item.nomeColuna]}
          placeholder={item.rotulo}
          id={item.nomeColuna}
          class="form-control"
          disabled={item.readonly}
          maxlength={item.tamanho}
        />
      {:else if item.tipo === Tipo.TELEFONE}
        <input
          type="tel"
          bind:value={retorno[item.nomeColuna]}
          placeholder={item.rotulo}
          id={item.nomeColuna}
          class="form-control"
          disabled={item.readonly}
          maxlength={item.tamanho}
        />
      {:else if item.tipo === Tipo.TIME}
        <input
          type="time"
          bind:value={retorno[item.nomeColuna]}
          maxlength={item.tamanho}
          placeholder={item.rotulo}
          id={item.nomeColuna}
          class={getInputClass(item)}
        />
      {:else if item.tipo === Tipo.SELECAO}
        <DropDownDb
          config={item.config_drop_down}
          saida={PegaValor(retorno[item.nomeColuna])}
          on:retorno_edicao={(e) => (retorno[item.nomeColuna] = e.detail)}
        />
      {:else if item.tipo === Tipo.DATA}
        <input
          type="date"
          bind:value={retorno[item.nomeColuna]}
          maxlength={item.tamanho}
          placeholder={item.rotulo}
          id={item.nomeColuna}
          class={getInputClass(item)}
        />{:else if item.tipo === Tipo.HIDDEN}
        <input
          type="hidden"
          value={retorno[item.nomeColuna]}
          maxlength={item.tamanho}
          placeholder={item.rotulo}
          id={item.nomeColuna}
          class={getInputClass(item)}
        />
      {:else if item.tipo === Tipo.TG}
        {#if retorno[item.nomeColuna] == 0}
          <Switch
            on:change={() =>
              (retorno[item.nomeColuna] = MudaTG(retorno[item.nomeColuna]))}
            id={item.nomeColuna}
          />
        {:else}
          <Switch
            checked={retorno[item.nomeColuna]}
            on:change={() =>
              (retorno[item.nomeColuna] = MudaTG(retorno[item.nomeColuna]))}
            id={item.nomeColuna}
          />
        {/if}
      {/if}
    </div>
  {/each}
  <slot></slot>
</div>
{#if deleta}
  <button class="btn btn-block botao-laranja" on:click={() => ConfirmaEdicao(1)}
    >{textoBotaoDeletar}</button
  >
{/if}
{#if edita}
  <button class="btn btn-block botao-laranja" on:click={() => ConfirmaEdicao(2)}
    >{textoBotaoEditar}</button
  >
{/if}
{#if mensagem != ""}
  {#if response && response.sucesso}
    <CaixaDeDialogo2
      target={"#modal"}
      message={mensagem}
      on:close={() => {
        mensagem = "";
        NavegarAposAtualizar();

        //retorno = "";
      }}
    />
  {:else if response.motivo == "duplicado"}
    <CaixaDeDialogo
      message={mensagem}
      on:close={() => {
        mensagem = "";
        // retorno = "";
      }}
    />
  {:else}
    <CaixaDeDialogo
      message={mensagem}
      on:close={() => {
        mensagem = "";
        // retorno = "";
      }}
      button1Label={Constantes.botao_negativo}
      button3Label={Constantes.botao_positivo}
      button3Action={SalvaEdicao}
    />
  {/if}
{/if}

<style>
  .botao-laranja {
    background-color: #f38c23;
    color: white;
  }
  .header-bar {
    background-color: #459bfd;
    padding-left: 10px;
    padding-top: 5px;
    padding-bottom: 5px;
    color: #ffffff;
    margin-bottom: 10px;
    margin-top: 15px;
    margin-left: 16px;
    margin-right: 16px;
  }

  .card1 {
    width: 100%;
    padding: 15px;

    margin-bottom: 15px;
  }

  .form-group {
    margin-bottom: 15px;
  }

  .form-control {
    width: 100%;
    padding: 0.375rem 0.75rem;
    font-size: 1rem;
    line-height: 1.5;
    color: #495057;
    background-color: #fff;
    background-clip: padding-box;
    border: 1px solid #ced4da;
    border-radius: 0.25rem;
    transition:
      border-color 0.15s ease-in-out,
      box-shadow 0.15s ease-in-out;
  }

  .tel-input {
    /* Estilos adicionais para campos de telefone */
  }

  input {
    margin-bottom: 10px;
    padding: 5px;
    border: 1px solid #ccc;
    border-radius: 4px;
  }
</style>
